<template>
  <div class="about">
    <div v-if="stepLogin === 0">
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#274561" loader="dots" :height="120" :width="120"></loading>
    </div>
    <div v-else>
      <registrati-spid :accessToken="access_token" :jsonData="jsonData" :enabledSesso="enabledSesso" :enabledMail="enabledMail" @setStep="setStep" @accedi="accedi"></registrati-spid>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import RegistratiSpid from "../registrati/registratiSpid.vue";
import AuthService from "@/services/authService";
import getVocabolario from "@/utilities/utilityCercaVocabolario";
import OAuth2Handler from "../../../oidcAuth/oidcLogin";
export default {
  components: { Loading, RegistratiSpid },
  data() {
    return {
      pathResourceInvioToken: "/api/v2.0/appecupt/auth/datispid",
      pathRestLogin: "/api/v2.0/appecupt/auth/login",
      access_token: null,
      isLoading: false,
      stepLogin: 0,
      jsonData: {},
      enabledSesso: false,
      enabledMail: false
    };
  },
  mounted: async function () {
    this.isLoading = true;
    try{
      const oAuth2Handler = new OAuth2Handler()
      const response = await oAuth2Handler.fetchToken(this.$route.query)
      if(response) {
        const responseSpid = await AuthService.verificaTokenSpid(response.access_token);
        this.access_token = response.access_token
        this.isLoading = false;
        if (responseSpid.data.stato === 200) {
          try {
            const responseTokenApi = await AuthService.tokenApi();
            sessionStorage.setItem("apiToken", responseTokenApi.data.data.access_token);
            if (responseSpid.data.data.codice === 0) {
              this.onAccediSpid();
            } else if (responseSpid.data.data.codice === 3) {
              this.jsonData = responseSpid.data.data.dati;
              if (!this.jsonData.sesso)
                this.enabledSesso = true;
              if (!this.jsonData.email) {
                this.enabledMail = true;

              }
              this.stepLogin = 1;
            }
          } catch (e) {
            console.log(e);
          }
        }
      }
    }catch (e) {
      this.isLoading=false
     await this.$bvModal.msgBoxOk("Errore nella login riprovare", {
        title: "Errore Login",
        size: "sm",
        okVariant: "outline-danger",
        headerClass: "vv-msg-header-danger",
        footerClass: "p-2 border-top-0",
        centered: true,
      });
      window.location = "/#"
    }
  },
  methods: {
    async onAccediSpid() {
      let me = this;
      me.isLoading = true;
      try {
        const responseLogin = await AuthService.login(me.access_token);
        if (responseLogin.data.stato === 200 || responseLogin.data.stato === 201) {
          me.isLoading = false;
          sessionStorage.setItem(
            "messaggiUtente",
            JSON.stringify({
              messaggioPrePagamento: responseLogin.data.data.messaggioPrePagamento,
              messaggioPrePrenotazione: responseLogin.data.data.messaggioPrePrenotazione,
              piuReparti: responseLogin.data.data.piu_reparti,
              preAnnullamento: responseLogin.data.data.pre_annullamento,
            })
          );
          sessionStorage.setItem("loginData", responseLogin.data.data.token);
          sessionStorage.setItem(
            "serviziAttivi",
            JSON.stringify({
              prenotazionePending: responseLogin.data.data.prenotazionePending,
              loginStruttura: responseLogin.data.data.loginStruttura,
              visualizzaTermini: responseLogin.data.data.visualizzaTermini,
              contattiIsEnable: responseLogin.data.data.contattiIsEnable,
              servizioIsEnable: responseLogin.data.data.servizioIsEnable,
              pagamentiIsEnable: responseLogin.data.data.pagamentiIsEnable,
              refertiIsEnable: responseLogin.data.data.refertiIsEnable,
              prenotazioneIsEnable: responseLogin.data.data.prenotazioneIsEnable,
              appuntamentiIsEnable: responseLogin.data.data.appuntamentiIsEnable,
              cambioOperatoreIsEnable: responseLogin.data.data.cambioOperatoreIsEnable,
              screening: responseLogin.data.data.screening,
            })
          );
          if (responseLogin.data.data.servizioIsEnable) {
            me.$router.push({
              name: "Prenota",
              query: { authToken: responseLogin.data.access_token },
            });
          } else {
              let msg = getVocabolario("serverIndisponibile")
              if(!msg)
                  msg = "Il servizio non è al momento disponibile"
            this.$bvModal
              .msgBoxOk(msg, {
                title: "Attenzione!",
                size: "sm",
                okVariant: "outline-danger",
                headerClass: "vv-msg-header-danger",
                footerClass: "p-2 border-top-0",
                centered: true,
              })
              .then(() => {
                me.$router.push("/");
              });
          }
        }
      } catch (error) {
        console.log(error);
        me.isLoading = false;
        this.$bvModal.msgBoxOk(error.response.data, {
          title: "Errore Login",
          size: "sm",
          okVariant: "outline-danger",
          headerClass: "vv-msg-header-danger",
          footerClass: "p-2 border-top-0",
          centered: true,
        });
      }
    },
    accedi() {
      let me = this;
      me.onAccediSpid();
    },
    setStep(step) {
      let me = this;
      console.log(step);
      me.stepLogin = step;
    },
    getJsonData(value) {
      let me = this;
      me.jsonData = value;
    },
  },
};
</script>
<style>
.claims {
  list-style: none;
  text-align: left;
}
</style>
